import { useParams } from 'react-router-dom';
import Button from 'antd/es/button';
import Card from 'antd/es/card';
import Divider from 'antd/es/divider';
import Form from 'antd/es/form';
import Input from 'antd/es/input';
import Skeleton from 'antd/es/skeleton';
import Typography from 'antd/es/typography';
import { useTranslation } from 'react-i18next';
import { useUnit } from 'effector-react';
import { useState } from 'react';
import LanguageSelector from '../../components/LanguageSelector/LanguageSelector.jsx';
import BizPollQuestions from './BizPollQuestions.jsx';
import {
  $binInfo,
  $submitStatus,
  BizPollGate,
  getBinInfoEv,
  getBizPollOptsFx,
  submitFormEv,
} from '../../models/bizPollsModel/index';
import WrongTypeModal from './WrongTypeModal.jsx';
import GovCantVoteModal from './GovCantVoteModal.jsx';
import style from './BizPolls.module.css';
import {
  PollExclamationIcon,
  PollIcon,
  PollResultIcon,
  PollTargetIcon,
} from '../../utils/customIcons.jsx';

const blocksDict = {
  small: {
    // 14: [15, 4],
    24: [25, 4],
  },
  medium: {},
};

const yearBlocksDict = {
  small: {
    '55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77': [
      [78, 79, 80, 81],
      4,
    ],
  },
  medium: {},
};

export default function BizPolls({ year }) {
  const { type } = useParams();
  const { t } = useTranslation();
  const getBin = useUnit(getBinInfoEv);
  const submit = useUnit(submitFormEv);
  const binInfo = useUnit($binInfo);
  const submitStatus = useUnit($submitStatus);
  const loading = useUnit(getBizPollOptsFx.pending);
  const [pollForm] = Form.useForm();
  const [binCorrect, setBinCorrect] = useState(false);

  const [blocked, setBlocked] = useState([]);
  const [blockedOptions, setBlockedOptions] = useState({});

  const blockManager = (changedValues, allValues) => {
    if (year && type === 'small') {
      const fifthQKey = Object.keys(yearBlocksDict[type])[0];
      const fifthQs = fifthQKey.split(',');
      if (!binCorrect) return;
      if (
        fifthQs.every(
          (id) => +allValues[id].value === yearBlocksDict[type][fifthQKey][1]
        )
      ) {
        setBlocked([...blocked, ...yearBlocksDict[type][fifthQKey][0]]);
      } else if (
        yearBlocksDict[type][fifthQKey][0].every((item) =>
          blocked.includes(item)
        )
      ) {
        setBlocked([
          ...blocked.filter(
            (item) => !yearBlocksDict[type][fifthQKey][0].includes(item)
          ),
        ]);
      }

      const sixthQ = [78, 79, 80];
      if (sixthQ.includes(+Object.keys(changedValues)[0])) {
        let neverCount = 0;
        const sixthQValues = Object.fromEntries(
          sixthQ.map((item) => {
            if (allValues[item].value === '4') neverCount += 1;
            return [item, allValues[item].value];
          })
        );
        if (neverCount === 2) {
          const nonNeverQ = sixthQ.filter((item) => sixthQValues[item] !== '4');
          setBlockedOptions({
            ...blockedOptions,
            [nonNeverQ]: 4,
          });
        } else if (Object.keys(blockedOptions).length > 0) {
          setBlockedOptions({});
        }
      }
    } else if (/\d+/g.test(Object.keys(changedValues)[0])) {
      const [id, { value }] = Object.entries(changedValues)[0];
      if (blocksDict[type][id] && blocksDict[type][id].includes(+value)) {
        setBlocked([...blocked, blocksDict[type][id][0]]);
      } else if (
        blocksDict[type][id] &&
        !blocksDict[type][id].includes(+value)
      ) {
        setBlocked([
          ...blocked.filter((item) => item !== blocksDict[type][id][0]),
        ]);
      }
    }
  };

  // if (year) {
  //   return (
  //     <Card
  //       style={{
  //         position: 'fixed',
  //         top: '50%',
  //         right: '50%',
  //         transform: 'translate(50%, -50%)',
  //       }}
  //     >
  //       <div
  //         style={{
  //           textAlign: 'center',
  //           fontSize: '28px',
  //         }}
  //       >
  //         Опрос завершен
  //       </div>
  //     </Card>
  //   );
  // }

  document.onkeydown = (e) => {
    if (e.code === 'Enter' || e.code === 'NumpadEnter') {
      e.preventDefault();
    }
  };

  return (
    <div className={style.page_cnt}>
      <div className={style.page_title_cnt}>
        <h3>
          {type === 'small' ? t('biz-polls.titleSm') : t('biz-polls.titleMd')}
        </h3>
        <LanguageSelector />
      </div>
      <WrongTypeModal year={year} />
      <GovCantVoteModal />
      <BizPollGate type={type} />
      {submitStatus ? (
        <Typography.Paragraph>{t('biz-polls.success')}</Typography.Paragraph>
      ) : loading ? (
        <Skeleton />
      ) : (
        <>
          <div className={style.content_card}>
            <div className={style.title_card}>
              <div className={style.title_text_cnt}>
                <p className={style.title_header}>Уважаемый респондент!</p>
                <span className={style.title_text}>
                  Просим вас принять участие в опросе, который проводит НПП РК
                  «Атамекен» (г. Астана) на основании Закона РК «О Национальной
                  палате предпринимателей Республики Казахстан» (пункт 2 статьи
                  10).
                </span>
              </div>
              <div className={style.title_icon}>{PollIcon}</div>
            </div>
            <div className={style.info_grid}>
              <div className={style.info_card}>
                {PollTargetIcon}
                <span>
                  Целью опроса является оценка и сопоставления результатов
                  работы центральных государственных и местных исполнительных
                  органов по созданию условий ведения предпринимательской
                  деятельности по приоритетным отраслям и видам экономической
                  деятельности каждого отдельного района и города.
                </span>
              </div>
              <div className={style.info_card}>
                {PollResultIcon}
                <span>
                  Результаты исследования будут проанализированы и использованы
                  в дальнейшем в качестве базовой информации для сравнительного
                  анализа развития предпринимательства в разрезе регионов,
                  городов и районов, а также выработки предложений для развития
                  бизнеса в 17 областях и 3 городах республиканского значения, с
                  учётом их региональной специфики и барьеров.
                </span>
              </div>
              <div className={style.info_card}>
                {PollExclamationIcon}
                <span>
                  Для нас важно мнение каждого. Итоги и результаты опроса будут
                  в полном объёме доведены до руководства страны и
                  Правительства. Уверяем вас, что ваше мнение будет не только
                  услышано, но и найдёт конкретную реализацию. Вашему вниманию
                  предложен ряд вопросов и варианты ответов на них. Прочитайте,
                  пожалуйста, их до конца и выберите устраивающий вас ответ.
                  Полученная информация будет использована исключительно в
                  обобщённом виде.
                </span>
              </div>
            </div>
          </div>
          <Form
            form={pollForm}
            name="pollForm"
            onFinish={(values) => {
              submit(values);
            }}
            preserve={false}
            layout="vertical"
            scrollToFirstError
          >
            <div
              className={
                binInfo
                  ? style.participant_info_found
                  : style.participant_info_cnt_empty
              }
            >
              <div className={`${style.content_card} ${style.bin_search_card}`}>
                <div className={style.bin_search_cnt}>
                  <div className={style.bin_search_form}>
                    <Form.Item
                      name="gov_id"
                      style={{ marginBottom: 0 }}
                      label={t('biz-polls.bin')}
                      validationTrigger={['onChange', 'onBlur']}
                      rules={[
                        { required: true, message: t('Обязательное поле') },
                        {
                          validator: async (rule, value) => {
                            if (value && value.length === 12) {
                              setBinCorrect(true);
                              return Promise.resolve();
                            }
                            if (!value || (value && value.length !== 12)) {
                              setBinCorrect(false);
                              return Promise.reject(
                                new Error('БИН/ИИН должен состоять из 12 цифр')
                              );
                            }
                          },
                        },
                      ]}
                    >
                      <Input
                        showCount
                        maxLength={12}
                        onPressEnter={() =>
                          getBin(pollForm.getFieldValue('gov_id'))
                        }
                      />
                    </Form.Item>
                    <Button
                      type="primary"
                      onClick={() => getBin(pollForm.getFieldValue('gov_id'))}
                      disabled={!binCorrect}
                    >
                      {t('biz-polls.search')}
                    </Button>
                  </div>
                  <span className={style.bin_search_warning}>
                    Анонимность и конфиденциальность Вашего мнения
                    гарантируется.
                  </span>
                </div>
              </div>
              {binInfo && (
                <div className={`${style.content_card} ${style.bin_info_card}`}>
                  <div className={style.bin_info_cnt}>
                    <div className={style.bin_info_item}>
                      <span className={style.bin_info_item_title}>
                        {t('biz-polls.bin-info.name')}
                      </span>
                      <span className={style.bin_info_item_value}>
                        {binInfo?.business_name_ru}
                      </span>
                    </div>
                    <div className={style.bin_info_item}>
                      <span className={style.bin_info_item_title}>
                        {t('biz-polls.bin-info.kato')}
                      </span>
                      <span className={style.bin_info_item_value}>
                        {binInfo?.kato_level_0}
                      </span>
                    </div>
                    <div className={style.bin_info_item}>
                      <span className={style.bin_info_item_title}>
                        {t('biz-polls.bin-info.oked')}
                      </span>
                      <span className={style.bin_info_item_value}>
                        {binInfo?.oked_level_4}
                      </span>
                    </div>
                    <div className={style.bin_info_item}>
                      <span className={style.bin_info_item_title}>
                        {t('biz-polls.bin-info.krp')}
                      </span>
                      <span className={style.bin_info_item_value}>
                        {binInfo?.krp_name_ru}
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {binInfo && (
              <>
                <Divider />
                <BizPollQuestions
                  type={type}
                  pollForm={pollForm}
                  blocked={blocked}
                  blockedOptions={blockedOptions}
                  year={year}
                />
              </>
            )}
          </Form>
        </>
      )}
    </div>
  );
}
